export default __webpack_public_path__ + "static/media/ae7ee922fff859d7.0301b3bc8185d7671e363722b5d712ab.svg";